import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Stack, Text, Secondary } from "braid-design-system";
import { translations } from "../../../../private/components/EmailPreview/.vocab/index.mjs";
import { previewContainer } from "./index.css.mjs";
const EmailPreview = ({
  senderFirstName = "",
  senderLastName = "",
  jobTitle = "",
  jobId = "0"
}) => {
  const { t } = useTranslations(translations);
  const firstNameAndSecondName = Boolean(senderFirstName) && Boolean(senderLastName);
  const eitherFirstNameOrLastName = Boolean(senderFirstName) || Boolean(senderLastName);
  const EmailPreviewLabel = () => {
    if (firstNameAndSecondName) {
      return /* @__PURE__ */ jsx(Fragment, { children: t("Full name teamMember has added you to the following job", {
        firstName: senderFirstName,
        lastName: senderLastName
      }) });
    }
    if (eitherFirstNameOrLastName) {
      return /* @__PURE__ */ jsx(Fragment, { children: t("Partial name teamMember has added you to the following job", {
        name: senderFirstName + senderLastName
      }) });
    }
    return /* @__PURE__ */ jsx(Fragment, { children: t("A team member has added you to the following job") });
  };
  return /* @__PURE__ */ jsx(Box, { className: previewContainer, children: /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
    /* @__PURE__ */ jsx(Box, { "data-hj-suppress": true, children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(Secondary, { children: /* @__PURE__ */ jsx(EmailPreviewLabel, {}) }) }) }),
    /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(Secondary, { children: jobTitle }) }),
    /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(Secondary, { children: t("Job", { jobId }) }) })
  ] }) });
};
export {
  EmailPreview
};
